var _rect, _circle, _g, _circle2, _g2, _g3, _text, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfinite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 167.2 249.4",
    enableBackground: "new 0 0 167.2 249.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -6.3,
    y: -5.6,
    fill: "#78CBE7",
    width: 178.6,
    height: 260.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#BA3033",
    cx: 23.8,
    cy: 39.2,
    r: 2.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 15.3207 28.6079)",
    fontFamily: "'AvenirNext-Regular'",
    fontSize: 23
  }, "\u221E"))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#BA3033",
    cx: 143.4,
    cy: 210.3,
    r: 2.6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F2F2",
    d: "M125.5,32.8c-2.7,1-4.1,4.1-3.1,6.8c1,2.7,4.1,4.1,6.8,3.1c6.1-2.3,8.9-14.6,8.9-14.6 S125.8,32.7,125.5,32.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FBDAE6",
    points: "109.6,62.5 108.8,60 106.2,60.4 115.9,44.6 119.4,46.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F5A5C4",
    points: "109.6,62.5 108.8,60 106.2,60.4 108,57.4 111.5,59.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FBDAE6",
    points: "122.1,69.9 121.2,67.3 118.6,67.7 128.4,52 131.8,54.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F5A5C4",
    points: "122.1,69.9 121.2,67.3 118.6,67.7 120.5,64.8 123.9,66.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FBDAE6",
    points: "128.2,73.6 127.3,71.1 124.7,71.5 134.4,55.7 137.9,57.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F5A5C4",
    points: "128.2,73.6 127.3,71.1 124.7,71.5 126.6,68.5 130,70.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FBDAE6",
    d: "M116.1,52.8l2.6-3.1l-5.4-4.4c0,0,0,0,0,0c-1.1-1.1-2.3-0.5-2.8-0.3c-0.5,0.2-11.7,5.1-11.7,5.1l2.4,1.2 l-0.7,2.6l11-4.8L116.1,52.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F5A5C4",
    points: "100.5,53.8 101.2,51.2 98.9,50.1 102.1,48.7 103.7,52.4  "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FBDAE6",
    d: "M110,43.5l1.4-2.3c2.2-3.6,7-4.7,10.5-2.5l13.6,8.4c3.6,2.2,4.7,7,2.5,10.5l-1.4,2.3 c-2.2,3.6-7,4.7-10.5,2.5L112.5,54C108.9,51.8,107.8,47.1,110,43.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.5,
    y: 57.7,
    transform: "matrix(0.8514 0.5244 -0.5244 0.8514 50.3122 -57.5305)",
    fill: "#FBDAE6",
    width: 14.4,
    height: 4.6
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E7E8",
    d: "M133.3,39c-3.5-1.7-7.7-0.2-9.4,3.3c-1.7,3.5-0.2,7.7,3.3,9.4c7.9,3.8,22.3-4.9,22.3-4.9 S133.6,39.1,133.3,39z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F9C8DA",
    d: "M126.4,36.7c-1.9-0.3-3.7,0.4-5,1.7c0.8,1.6,2.3,2.8,4.2,3.1c1.9,0.3,3.7-0.4,5-1.7 C129.9,38.2,128.3,37,126.4,36.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5A5C4",
    d: "M126.3,37.5c-1.3-0.2-2.5,0.3-3.3,1.1c0.5,1.1,1.5,1.9,2.8,2.1c1.3,0.2,2.5-0.3,3.3-1.1 C128.6,38.5,127.6,37.7,126.3,37.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F9C8DA",
    d: "M119.7,27.8c-1.1,1.6-1.2,3.6-0.5,5.2c1.8,0,3.6-0.9,4.6-2.5c1.1-1.6,1.2-3.6,0.5-5.2 C122.6,25.4,120.8,26.2,119.7,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBDAE6",
    d: "M121.1,30.2c-2-1.3-3.6-2-6.5-1.4c-2.9,0.7-3.2,1.7-6.2,0.2c-0.5-0.3-1.6,0.5-2.5,1.8 c-0.9,1.3-1.2,2.7-0.7,3c0,0,2.1,1.4,2.5,5.5c0.2,1.8,1.4,4.4,3.4,5.8c4.1,2.7,9.7,1.6,12.4-2.5S125.2,33,121.1,30.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.832 0.5547 -0.5547 0.832 34.9625 -54.029)",
    fill: "#F5A5C4",
    cx: 106.7,
    cy: 30.7,
    rx: 0.1,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.832 0.5547 -0.5547 0.832 35.4591 -53.9431)",
    fill: "#F5A5C4",
    cx: 106.8,
    cy: 31.6,
    rx: 0.1,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 117.6,
    cy: 36.4,
    r: 1.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M118.1,36.7c-0.2-0.1-0.3-0.4-0.2-0.7c0.1-0.2,0.3-0.3,0.4-0.3c-0.1-0.1-0.2-0.1-0.3-0.2 c-0.5-0.3-1.1-0.1-1.3,0.4c-0.3,0.5-0.1,1.1,0.4,1.3s1.1,0.1,1.3-0.4c0-0.1,0.1-0.1,0.1-0.2C118.5,36.7,118.3,36.7,118.1,36.7z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#F5A5C4",
    d: "M110,37.4l-0.6-0.1c-0.2,0.7-0.9,1.2-1.6,1.1c-0.1,0-0.2,0-0.3-0.1c0,0.2,0.1,0.4,0.1,0.6c0,0,0,0,0,0 C108.8,39.2,109.8,38.5,110,37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBDAE6",
    d: "M109.1,42.9c0,0,0.7,1.1,0.5,2.3c-0.3,1.2,3.9-1.3,3.9-1.3l-2.8-1.9L109.1,42.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FBDAE6",
    points: "137,57.2 137.9,57.1 138.2,61  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F2F2",
    cx: 31.1,
    cy: 78.7,
    r: 15.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F2F2",
    cx: 46.6,
    cy: 70.4,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F2F2",
    cx: 51.5,
    cy: 86.2,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F2F2",
    cx: 57.3,
    cy: 74.3,
    r: 5.2
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 27.863 153.6833)",
    fontFamily: "'AvenirNext-UltraLight'",
    fontSize: 160
  }, "\u221E")), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F2F2",
    cx: 140.1,
    cy: 139.8,
    r: 12.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F2F2",
    cx: 130.7,
    cy: 129,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F2F2",
    cx: 122.5,
    cy: 139.7,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F2F2",
    cx: 121.5,
    cy: 129,
    r: 4.2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F2F2",
    cx: 83.1,
    cy: 5.8,
    r: 12.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F2F2",
    cx: 97.3,
    cy: 6.7,
    r: 6.7
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F2F2",
    cx: 115.4,
    cy: 236.7,
    r: 18.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F2F2",
    cx: 141.1,
    cy: 240.2,
    r: 14.3
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(-1 0 0 -1 151.9254 220.8387)",
    fontFamily: "'AvenirNext-Regular'",
    fontSize: 23
  }, "\u221E"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F2F2",
    d: "M60.3,166.1c4.5,1.7,6.8,6.8,5.1,11.3c-1.7,4.5-6.8,6.8-11.3,5.1c-10.2-3.9-14.8-24.3-14.8-24.3 S59.8,165.9,60.3,166.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FBDAE6",
    points: "47.5,235.3 50,231.7 54,233.5 45.5,203.8 39,205.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F5A5C4",
    points: "47.5,235.3 50,231.7 54,233.5 52.4,227.9 45.9,229.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FBDAE6",
    points: "59.3,231.8 61.8,228.1 65.8,229.9 57.3,200.3 50.7,202.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F5A5C4",
    points: "59.3,231.8 61.8,228.1 65.8,229.9 64.2,224.3 57.6,226.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FBDAE6",
    d: "M74,201l-4.3-5.2l9-7.4c0,0,0,0,0.1-0.1c1.9-1.8,3.8-0.8,4.6-0.4c0.8,0.4,19.4,8.6,19.4,8.6l-3.9,1.9 l1.2,4.3l-18.2-8.1L74,201z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F5A5C4",
    points: "100,202.6 98.7,198.4 102.7,196.4 97.4,194.1 94.6,200.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FBDAE6",
    d: "M68.5,206.5l-2.6-6.3l10.7-4.5c0,0,0.1,0,0.1,0c2.3-1.1,3.9,0.4,4.5,0.9c0.7,0.6,16.1,13.9,16.1,13.9 l-4.3,0.7l-0.1,4.4l-15.1-13L68.5,206.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F5A5C4",
    points: "92.9,215.6 93,211.2 97.3,210.5 92.9,206.7 88.5,211.8  "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FBDAE6",
    d: "M86.1,183.9l-2.4-3.9c-3.7-6-11.6-7.9-17.6-4.2l-22.6,13.9c-6,3.7-7.9,11.6-4.2,17.6l2.4,3.9 c3.7,6,11.6,7.9,17.6,4.2l22.6-13.9C87.9,197.8,89.8,189.8,86.1,183.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E7E8",
    d: "M44.2,174c6.7-3.2,14.7-0.4,17.9,6.3c3.2,6.7,0.4,14.7-6.3,17.9c-15.1,7.3-42.6-9.3-42.6-9.3 S43.6,174.3,44.2,174z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F9C8DA",
    d: "M58.7,172.6c3.2-0.5,6.2,0.7,8.3,2.9c-1.3,2.7-3.8,4.7-7,5.2c-3.2,0.5-6.2-0.7-8.3-2.9 C53,175.1,55.5,173.1,58.7,172.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5A5C4",
    d: "M58.9,174c2.1-0.3,4.1,0.5,5.5,1.9c-0.9,1.8-2.6,3.2-4.7,3.5c-2.1,0.3-4.1-0.5-5.5-1.9 C55.1,175.7,56.8,174.3,58.9,174z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F9C8DA",
    d: "M69.9,157.8c1.8,2.7,2,5.9,0.9,8.7c-3,0-5.9-1.5-7.7-4.1s-2-5.9-0.9-8.7C65.1,153.7,68.1,155.2,69.9,157.8z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBDAE6",
    d: "M67.6,161.8c3.3-2.2,6.1-3.4,10.8-2.3c4.8,1.1,5.3,2.8,10.3,0.3c0.8-0.5,2.6,0.8,4.1,3c1.5,2.2,2,4.4,1.2,5 c0,0-3.5,2.3-4.2,9.1c-0.3,2.9-2.4,7.4-5.7,9.6c-6.8,4.6-16.1,2.7-20.6-4.1C59,175.6,60.8,166.4,67.6,161.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.832 0.5547 -0.5547 -0.832 258.0256 247.1088)",
    fill: "#F5A5C4",
    cx: 91.6,
    cy: 162.6,
    rx: 0.2,
    ry: 0.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.832 0.5547 -0.5547 -0.832 258.4982 249.841)",
    fill: "#F5A5C4",
    cx: 91.4,
    cy: 164.1,
    rx: 0.2,
    ry: 0.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 73.4,
    cy: 172.1,
    r: 2.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M72.6,172.5c0.4-0.2,0.6-0.7,0.4-1.1c-0.1-0.3-0.4-0.4-0.7-0.4c0.1-0.1,0.3-0.2,0.4-0.3 c0.8-0.4,1.8-0.1,2.2,0.7c0.4,0.8,0.1,1.8-0.7,2.2c-0.8,0.4-1.8,0.1-2.2-0.7c-0.1-0.1-0.1-0.2-0.1-0.4 C72,172.6,72.3,172.7,72.6,172.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#F5A5C4",
    d: "M86,173.8l0.9-0.2c0.3,1.2,1.5,2,2.7,1.8c0.2,0,0.3-0.1,0.4-0.1c-0.1,0.3-0.1,0.7-0.2,1c0,0,0,0-0.1,0 C88.1,176.7,86.4,175.6,86,173.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBDAE6",
    d: "M87.6,182.9c0,0-1.2,1.9-0.8,3.8c0.5,1.9-6.6-2.2-6.6-2.2l4.7-3.2L87.6,182.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FBDAE6",
    points: "41.1,204.6 38.9,203.9 36.1,212.1  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinite);
export default __webpack_public_path__ + "static/media/infinite.13d5b245c27037bf3f58ca303e93b3c5.svg";
export { ForwardRef as ReactComponent };